export default function Footer() {
  return (
    <footer className="border-t border-white/[0.05] py-10 px-6">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <span className="text-white font-bold text-lg tracking-tight">
          Code<span className="text-violet-400">Volt</span>
        </span>
        <p className="text-gray-600 text-xs">
          © {new Date().getFullYear()} Luis Vega Torres. All rights reserved.
        </p>
        <div className="flex gap-5">
          {[
            { label: 'Services', href: '#services' },
            { label: 'Portfolio', href: '#portfolio' },
            { label: 'Contact', href: '#contact' },
          ].map(({ label, href }) => (
            <a key={label} href={href} className="text-gray-500 hover:text-gray-300 text-xs transition-colors">
              {label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
